import { render, staticRenderFns } from "./optional-role.vue?vue&type=template&id=41fd66ef&scoped=true"
import script from "./optional-role.vue?vue&type=script&lang=js"
export * from "./optional-role.vue?vue&type=script&lang=js"
import style0 from "./optional-role.vue?vue&type=style&index=0&id=41fd66ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd66ef",
  null
  
)

export default component.exports